import { createContext, useContext, useRef, useState, useCallback } from "react";

const PlayerContext = createContext(null);

export function PlayerProvider({ children }) {
  const audioRef = useRef(null);
  const [current, setCurrent] = useState(null);
  const [playing, setPlaying] = useState(false);
  const [progress, setProgress] = useState(0);

  const toggle = useCallback(
    (track) => {
      const audio = audioRef.current;
      if (!audio) return;
      if (current?.id === track.id) {
        if (playing) {
          audio.pause();
          setPlaying(false);
        } else {
          audio.play().catch(() => {});
          setPlaying(true);
        }
      } else {
        setCurrent(track);
        setProgress(0);
        audio.src = track.audio;
        audio.play().catch(() => {});
        setPlaying(true);
      }
    },
    [current, playing],
  );

  const close = useCallback(() => {
    const audio = audioRef.current;
    if (audio) audio.pause();
    setPlaying(false);
    setCurrent(null);
  }, []);

  const onTimeUpdate = () => {
    const audio = audioRef.current;
    if (audio && audio.duration) {
      setProgress((audio.currentTime / audio.duration) * 100);
    }
  };

  return (
    <PlayerContext.Provider value={{ current, playing, progress, toggle, close }}>
      {children}
      <audio
        ref={audioRef}
        data-testid="global-audio-element"
        onTimeUpdate={onTimeUpdate}
        onEnded={() => setPlaying(false)}
      />
    </PlayerContext.Provider>
  );
}

export function usePlayer() {
  return useContext(PlayerContext);
}
